import { useState } from 'react';
import { useLazyQuestionnaireResultsQuery } from '../../../graphql/graphql';
import { FilledQuestionnaireSelectedItem } from '../Components/FilledQuestionnaireList/FilledQuestionnaireList';
import apiClient from '../../../Services/ApiClient';
import { useAppContext } from '../../../Services/AppContext';
import {
	QUESTIONNAIRE_ENTRY_CODE,
	QUESTIONNAIRE_REGULAR_CODE,
} from '../../HealthPlan/constants';
import useTranslation from '../../../Hooks/useTranslation';

export default function useQuestionnaireResults() {
	const [getQuestionnaireResultsQuery, { data, isLoading }] =
		useLazyQuestionnaireResultsQuery();
	const [page, setPage] = useState(1);
	const { workplaceId, isLatam } = useAppContext();

	const getQuestionnaireResults = (filter: Record<string, any>) => {
		getQuestionnaireResultsQuery({
			...filter,
			excludeQuestionnaireCodes: [
				'latamDiabetesEntryQuestionnaireDoctor',
				'meddiBabyLatamEntry',
				'latamDiabetesEntryQuestionnaire',
				'meddiBabyLatamEntryDoctor',
			],
			workplaceIds: filter?.workplaceIds ?? [workplaceId],
			skip: (page - 1) * 20,
			take: 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	const markAllAsRead = async () => {
		await apiClient.post('/questionnaire/mark-as-seen', {});
	};

	const markAsRead = async (items: FilledQuestionnaireSelectedItem[]) => {
		for (const item of items || []) {
			const result = await apiClient.put(
				'/questionnaire/' + item.questionnaireId + '/result/' + item.id,
				{ seen: true },
			);
		}
	};

	const markAsUnRead = async (questionnaireId: string, resultId: string) => {
		const result = await apiClient.put(
			'/questionnaire/' + questionnaireId + '/result/' + resultId,
			{ seen: false },
		);
	};

	const getQuestionnaireNameByQuestionnaireCode = (
		questionnaireCode: string,
	) => {
		const names = [
			{
				questionnaireCode: QUESTIONNAIRE_REGULAR_CODE,
				questionnaireName: 'Pravidelná prohlídka',
			},
			{
				questionnaireCode: QUESTIONNAIRE_ENTRY_CODE,
				questionnaireName: 'Vstupní prohlídka',
			},
			{
				questionnaireCode: 'meddi_baby_czech_patient',
				questionnaireName: 'Dotazník pacientka',
			},
		];

		const questionnaire = names.find(
			questionnaire => questionnaire.questionnaireCode === questionnaireCode,
		);
		if (questionnaire) {
			return questionnaire.questionnaireName;
		}

		return null;
	};

	return {
		getQuestionnaireResults,
		getNextPage,
		markAsRead,
		markAsUnRead,
		markAllAsRead,
		data,
		isLoading,
		page,
		setPage,
		getQuestionnaireNameByQuestionnaireCode,
	};
}
